import React, {Component, Fragment} from 'react';
import BlogTrend from "../../components/statistics/blog/BlogTrend";
import BlogInflow from "../../components/statistics/blog/BlogInflow";
import BlogTopEntry from "../../components/statistics/blog/BlogTopEntry";
import BlogKeyword from "../../components/statistics/blog/BlogKeyword";
import { connect } from "react-redux";
import {setInit, setMinDate} from "../../actions/statistics/statisticsActions";
import CountNavigator from "../../components/statistics/common/CountNavigator";
import BlogPast from "../../components/statistics/blog/BlogPast";
import {checkAndGetMaintenanceMsg, getBlogCreatedDate} from "../../components/statistics/common/CommonHelper"
import Maintenance from "../../components/statistics/common/Maintenance";
import If from "../../components/common/control/If";
import moment from "moment";

@connect(state => ({
  minDate: state.statistics.minDate
}), dispatch => ({
  handleSetInit() {
    dispatch(setInit())
  },
  handlerSetMinDate(minDate) {
    dispatch(setMinDate(minDate))
  },
}))
class StatisticsBlogApp extends Component {
  constructor(props, context) {
    super(props, context);
    props.handleSetInit();
    this.state = {lastUpdateTime: null, isEarlierThanRenewal: false};
    this.maintenanceMsg = checkAndGetMaintenanceMsg();
    this.defindedMinDate = "2018-01-01";

  }

  // CountNavigator 마지막 갱신시간
  handleSetCountNavigatorLastUpdateTime = (lastUpdateTime) => {
    this.setState({
      lastUpdateTime: lastUpdateTime
    })
  };

  componentDidMount() {
    this.setBlogCreatationDate();
  }


  // 블로그 최초 생성일
  setBlogCreatationDate() {
    const minDate = getBlogCreatedDate();
    this.props.handlerSetMinDate(minDate);
    this.setState({
      isEarlierThanRenewal: (moment(minDate) < moment(this.defindedMinDate))
    })
  }

  render() {
    const {lastUpdateTime, isEarlierThanRenewal} = this.state;
    const isMaintenance = this.maintenanceMsg !== null;

    return (
      <div>
        <h3 className="tit_cont">방문 통계</h3>
        <If condition={isMaintenance}><Maintenance className="box_blog box_inspect" msg={this.maintenanceMsg}/></If>{/*점검페이지*/}
        <If condition={!isMaintenance}>
          <Fragment>
            <If condition={lastUpdateTime != null}><span className="info_rate_date">{lastUpdateTime} 기준</span></If>
            <CountNavigator handleSetCountNavigatorLastUpdateTime={this.handleSetCountNavigatorLastUpdateTime}/>
            <div className="box_blog">
              <Fragment>
                {/* 그래프 변화 추이 */}
                <BlogTrend/>
                {/* 상세 유입 정보 */}
                <BlogInflow/>
                {/* 인기 게시물 */}
                <BlogTopEntry/>
                {/* 인기 키워드 */}
                <BlogKeyword/>
              </Fragment>
            </div>
            {/* 2018이전데이터 */}
            <If condition={isEarlierThanRenewal}>
              <BlogPast/>
            </If>
          </Fragment>
        </If>
      </div>
    );
  }
}


export default StatisticsBlogApp;
